import ContractType from './ContractType'

class SpainContractType extends ContractType {
  static urlRoot() {
    return '/contracts/spain/contract_types'
  }
}

export default SpainContractType
